import type { ClientProfile } from './types'

/** Auto-generated from Clients List HTML — do not edit by hand. */
export const MOCK_CLIENTS: ClientProfile[] = [
  {
    id: "44021",
    lastName: "Bui",
    firstName: "Xuan ThuThi",
    phoneHome: "303-475-6229",
    phoneCell: "720-625-9468",
    photoUrl: "/clients/image_68d2d510621e5.png",
    status: "Approved",
    dob: "07/10/1946",
  },
  {
    id: "34022",
    lastName: "Casillas De Garcia",
    firstName: "Josefina",
    phoneHome: "303-917-3155",
    phoneCell: "720-545-6941",
    photoUrl: "/clients/image_66884ae9cc660.png",
    status: "Approved",
    dob: "02/28/1947",
  },
  {
    id: "48623",
    lastName: "Casillas",
    firstName: "Maria Del Refugio",
    phoneCell: "720-275-6659",
    photoUrl: "/clients/image_6a5a92f0a8251.png",
    status: "Visitor",
    dob: "07/03/1956",
  },
  {
    id: "41044",
    lastName: "Castorena",
    firstName: "Elvira",
    phoneCell: "720-346-8480",
    photoUrl: "/clients/image_68012bb373461.png",
    status: "Approved",
    dob: "01/19/1954",
  },
  {
    id: "41043",
    lastName: "Castorena",
    firstName: "Mauro",
    phoneHome: "720-435-4358",
    phoneCell: "720-435-4358",
    photoUrl: "/clients/image_68012bef23335.png",
    status: "Approved",
    dob: "06/27/1951",
  },
  {
    id: "43879",
    lastName: "Cruz",
    firstName: "Ceila",
    phoneHome: "720-653-5745",
    phoneCell: "720-653-5745",
    photoUrl: "/clients/image_68c843b884fae.png",
    status: "Approved",
    dob: "04/22/1970",
  },
  {
    id: "33638",
    lastName: "Dang",
    firstName: "Ich",
    phoneCell: "720-557-8404",
    photoUrl: "/clients/image_664e39ba35b99.png",
    status: "Approved",
    dob: "08/19/1947",
  },
  {
    id: "33959",
    lastName: "Dang",
    firstName: "Xue",
    phoneCell: "720-891-3107",
    photoUrl: "/clients/image_689a37390a94b.png",
    status: "Approved",
    dob: "05/02/1951",
  },
  {
    id: "38862",
    lastName: "Dao",
    firstName: "Hung Huu",
    phoneCell: "720-980-0557",
    photoUrl: "/clients/image_67ec1a74c7138.png",
    status: "Approved",
    dob: "09/06/1950",
  },
  {
    id: "46732",
    lastName: "Dau",
    firstName: "Dan Cong",
    phoneCell: "720-594-0224",
    photoUrl: "/clients/image_69bc6762942d3.png",
    status: "Visitor",
    dob: "10/10/1950",
  },
  {
    id: "46840",
    lastName: "Do",
    firstName: "Cuc Thi",
    phoneHome: "720-490-9226",
    phoneCell: "720-490-9226",
    photoUrl: "/clients/image_69cea5b5164de.png",
    status: "Approved",
    dob: "01/01/1945",
  },
  {
    id: "37852",
    lastName: "Do",
    firstName: "Loan T",
    phoneCell: "720-318-3822",
    photoUrl: "/clients/image_68efd4845f965.png",
    status: "Approved",
    dob: "05/16/1950",
  },
  {
    id: "46642",
    lastName: "Dong",
    firstName: "Cuc",
    phoneCell: "720-896-9221",
    photoUrl: "/clients/image_69f0fd79cf5c5.png",
    status: "Approved",
    dob: "10/24/1950",
  },
  {
    id: "47356",
    lastName: "Draper",
    firstName: "Michelle Denise",
    phoneCell: "832-545-9430",
    photoUrl: "/clients/image_69fcb936a11cc.png",
    status: "Visitor",
    dob: "01/02/1959",
  },
  {
    id: "33633",
    lastName: "Duong",
    firstName: "Quan",
    phoneCell: "720-935-6875",
    photoUrl: "/clients/image_664e3798bf999.png",
    status: "Approved",
    dob: "01/04/1946",
  },
  {
    id: "47425",
    lastName: "Escamilla",
    firstName: "Josephine",
    phoneHome: "303-935-3506",
    phoneCell: "303-935-3506",
    photoUrl: "/clients/image_69f4ca781ce30.png",
    status: "Visitor",
    dob: "02/06/1952",
  },
  {
    id: "47402",
    lastName: "Fonseca Torres",
    firstName: "Maria Guadalupe",
    phoneHome: "248-238-2002",
    phoneCell: "248-238-2002",
    photoUrl: "/clients/image_69f39f2ad4c87.png",
    status: "Visitor",
    dob: "09/19/1960",
  },
  {
    id: "47920",
    lastName: "Gamez",
    firstName: "Olivia",
    phoneCell: "720-234-0949",
    photoUrl: "/clients/image_6a452651a5bc6.png",
    status: "Visitor",
    dob: "07/04/1956",
  },
  {
    id: "37850",
    lastName: "Ha",
    firstName: "Duc Van",
    phoneCell: "720-207-4394",
    photoUrl: "/clients/image_67057660e7f32.png",
    status: "Approved",
    dob: "10/27/1947",
  },
  {
    id: "46414",
    lastName: "Hann",
    firstName: "Minh Giang",
    phoneCell: "720-999-2828",
    photoUrl: "/clients/image_699e17082935e.png",
    status: "Approved",
    dob: "10/06/1951",
  },
  {
    id: "40707",
    lastName: "Ho",
    firstName: "Lang",
    phoneCell: "303-642-6696",
    photoUrl: "/clients/image_67f805b7ee511.png",
    status: "Approved",
    dob: "09/19/1940",
  },
  {
    id: "42966",
    lastName: "Ho",
    firstName: "To",
    phoneCell: "720-933-0914",
    photoUrl: "/clients/image_689dfdc924b0c.png",
    status: "Approved",
    dob: "11/27/1952",
  },
  {
    id: "33017",
    lastName: "Hugh",
    firstName: "Bok Duck",
    phoneCell: "720-876-8025",
    photoUrl: "/clients/image_6650bf9e2b667.png",
    status: "Approved",
    dob: "01/29/1948",
  },
  {
    id: "42754",
    lastName: "Huynh",
    firstName: "Anh Thi Ngoc",
    phoneCell: "720-980-3328",
    photoUrl: "/clients/image_68810cc638196.png",
    status: "Approved",
    dob: "02/02/1952",
  },
  {
    id: "37993",
    lastName: "Huynh",
    firstName: "Mang",
    phoneCell: "303-332-1074",
    photoUrl: "/clients/image_672a78b307b11.png",
    status: "Approved",
    dob: "11/14/1959",
  },
  {
    id: "47049",
    lastName: "Huynh",
    firstName: "Quoc Lap",
    phoneCell: "720-548-7058",
    photoUrl: "/clients/image_69e695c7103fc.png",
    status: "Visitor",
    dob: "06/09/1947",
  },
  {
    id: "47330",
    lastName: "Huynh",
    firstName: "Vien Thi",
    status: "Visitor",
    dob: "11/20/1962",
  },
  {
    id: "47913",
    lastName: "Ibarra",
    firstName: "Josefina",
    phoneCell: "720-779-9801",
    photoUrl: "/clients/image_6a45262d0f06b.png",
    status: "Visitor",
    dob: "10/18/1957",
  },
  {
    id: "47773",
    lastName: "James",
    firstName: "Ishmuell",
    phoneCell: "580-967-9127",
    photoUrl: "/clients/image_6a1874a641b06.png",
    status: "Approved",
    dob: "07/28/1974",
  },
  {
    id: "43177",
    lastName: "Joe",
    firstName: "Test",
    status: "Visitor",
    dob: "01/01/1990",
  },
  {
    id: "46479",
    lastName: "Jones",
    firstName: "Bok Yon",
    phoneHome: "303-424-1364",
    photoUrl: "/clients/image_69f4d605cfb0a.png",
    status: "Visitor",
    dob: "01/07/1945",
  },
  {
    id: "42609",
    lastName: "Joosten",
    firstName: "Ok Cha",
    phoneCell: "720-503-3604",
    photoUrl: "/clients/image_6876948250ace.png",
    status: "Visitor",
    dob: "01/03/1944",
  },
  {
    id: "33229",
    lastName: "Khuu",
    firstName: "Hoa",
    phoneCell: "303-755-1118",
    photoUrl: "/clients/image_6667606d030a9.png",
    status: "Approved",
    dob: "11/16/1938",
  },
  {
    id: "33790",
    lastName: "Kim",
    firstName: "Eun Soo",
    phoneCell: "720-388-5097",
    photoUrl: "/clients/image_677ed87018266.png",
    status: "Approved",
    dob: "04/21/1941",
  },
  {
    id: "33015",
    lastName: "Kim",
    firstName: "Jung Ja",
    phoneCell: "303-817-4302",
    photoUrl: "/clients/image_662be7724ee09.png",
    status: "Approved",
    dob: "07/13/1955",
  },
  {
    id: "33014",
    lastName: "Kim",
    firstName: "Ki Ja",
    phoneHome: "720-725-9735",
    phoneCell: "720-388-5097",
    photoUrl: "/clients/image_6650bf65b46be.png",
    status: "Approved",
    dob: "02/11/1944",
  },
  {
    id: "38309",
    lastName: "La",
    firstName: "Wa K",
    phoneCell: "720-324-0393",
    photoUrl: "/clients/image_675885f2e08f8.png",
    status: "Approved",
    dob: "06/07/1947",
  },
  {
    id: "46224",
    lastName: "Ladd",
    firstName: "Van",
    phoneCell: "720-323-1524",
    photoUrl: "/clients/image_6995e3488bcea.png",
    status: "Approved",
    dob: "07/20/1946",
  },
  {
    id: "46664",
    lastName: "Lai",
    firstName: "Sanh",
    phoneHome: "720-273-8733",
    status: "Approved",
    dob: "04/03/1938",
  },
  {
    id: "40708",
    lastName: "Lam",
    firstName: "Hoang Van",
    phoneCell: "626-540-7383",
    photoUrl: "/clients/image_67e2e8c6aed62.png",
    status: "Approved",
    dob: "12/01/1958",
  },
  {
    id: "45443",
    lastName: "Lam",
    firstName: "Hong Le",
    phoneHome: "303-808-1280",
    phoneCell: "303-250-1858",
    photoUrl: "/clients/image_694592547aad5.png",
    status: "Approved",
    dob: "03/01/1946",
  },
  {
    id: "46413",
    lastName: "Lam",
    firstName: "Tom",
    phoneCell: "720-296-5746",
    photoUrl: "/clients/image_699f45dbe7aaa.png",
    status: "Visitor",
    dob: "11/15/1953",
  },
  {
    id: "40500",
    lastName: "Le",
    firstName: "An Van",
    phoneCell: "720-609-8112",
    photoUrl: "/clients/image_67cf4089e969a.png",
    status: "Approved",
    dob: "03/02/1935",
  },
  {
    id: "47472",
    lastName: "Le",
    firstName: "Bich Loan",
    phoneHome: "720-503-9778",
    phoneCell: "720-503-9778",
    photoUrl: "/clients/image_69fcdd7f2276e.png",
    status: "Visitor",
    dob: "06/16/1959",
  },
  {
    id: "47915",
    lastName: "Le",
    firstName: "Dao Thi",
    phoneHome: "669-238-9934",
    photoUrl: "/clients/image_6a2af37156fd9.png",
    status: "Visitor",
    dob: "05/13/1956",
  },
  {
    id: "43117",
    lastName: "Le",
    firstName: "Dien",
    phoneCell: "714-677-7544",
    photoUrl: "/clients/image_69b8609f28ada.png",
    status: "Visitor",
    dob: "05/02/1948",
  },
  {
    id: "47889",
    lastName: "Le",
    firstName: "Hong Thi",
    phoneCell: "720-999-2251",
    photoUrl: "/clients/image_6a2af3b4aac79.png",
    status: "Visitor",
    dob: "10/31/1949",
  },
  {
    id: "44525",
    lastName: "Le",
    firstName: "Hue Thi",
    phoneCell: "720-436-6569",
    photoUrl: "/clients/image_68ff946aca7c9.png",
    status: "Approved",
    dob: "01/16/1950",
  },
  {
    id: "33635",
    lastName: "Le",
    firstName: "Mai",
    phoneCell: "720-949-3765",
    photoUrl: "/clients/image_664e384cb422d.png",
    status: "Approved",
    dob: "07/08/1942",
  },
  {
    id: "33648",
    lastName: "Le",
    firstName: "Sen Thi",
    phoneCell: "720-742-5041",
    photoUrl: "/clients/image_668844479c658.png",
    status: "Approved",
    dob: "05/01/1951",
  },
  {
    id: "41794",
    lastName: "Le",
    firstName: "Thanh Long",
    phoneCell: "720-461-1126",
    photoUrl: "/clients/image_69b96b85946eb.png",
    status: "Approved",
    dob: "02/22/1964",
  },
  {
    id: "42508",
    lastName: "Le",
    firstName: "Thu Thi",
    phoneCell: "720-779-6999",
    photoUrl: "/clients/image_686d595ec86b4.png",
    status: "Approved",
    dob: "01/01/1947",
  },
  {
    id: "33718",
    lastName: "Lee",
    firstName: "Cheon",
    phoneCell: "303-960-0659",
    photoUrl: "/clients/image_6657700e1cdda.png",
    status: "Approved",
    dob: "10/15/1941",
  },
  {
    id: "34119",
    lastName: "Lee",
    firstName: "Hyung M",
    phoneCell: "720-499-9641",
    photoUrl: "/clients/image_6697faa6731cf.png",
    status: "Approved",
    dob: "08/03/1939",
  },
  {
    id: "33798",
    lastName: "Lee",
    firstName: "Myoung Ja",
    phoneCell: "720-499-9640",
    photoUrl: "/clients/image_66674448ec4c9.png",
    status: "Approved",
    dob: "01/19/1941",
  },
  {
    id: "44628",
    lastName: "Li",
    firstName: "Yen Thuy",
    phoneCell: "720-236-0659",
    photoUrl: "/clients/image_6914cb0ccf0c6.png",
    status: "Approved",
    dob: "07/03/1949",
  },
  {
    id: "33644",
    lastName: "Lim",
    firstName: "Young Soo",
    phoneCell: "720-320-7242",
    photoUrl: "/clients/image_67f80c9c357c3.png",
    status: "Approved",
    dob: "02/13/1947",
  },
  {
    id: "47672",
    lastName: "Luong",
    firstName: "Benny",
    phoneCell: "720-382-3064",
    status: "Visitor",
    dob: "08/20/1948",
  },
  {
    id: "47040",
    lastName: "Luong",
    firstName: "Chien Thi",
    phoneCell: "303-359-9230",
    photoUrl: "/clients/image_69dff67c6c02c.png",
    status: "Approved",
    dob: "12/31/1947",
  },
  {
    id: "34239",
    lastName: "Luong",
    firstName: "Tinh Thi",
    phoneCell: "303-960-1829",
    photoUrl: "/clients/image_66a932182a34f.png",
    status: "Approved",
    dob: "02/02/1950",
  },
  {
    id: "42162",
    lastName: "Ly",
    firstName: "Hung",
    phoneHome: "720-377-7056",
    photoUrl: "/clients/image_6849dc91955a1.png",
    status: "Approved",
    dob: "02/14/1960",
  },
  {
    id: "47316",
    lastName: "Madrigal",
    firstName: "Elsie Gloria",
    phoneCell: "303-455-9514",
    photoUrl: "/clients/image_69ea5fa1afe10.png",
    status: "Visitor",
    dob: "03/11/1950",
  },
  {
    id: "46735",
    lastName: "Mai",
    firstName: "Huong Thi",
    phoneCell: "720-594-0224",
    photoUrl: "/clients/image_69bc677b22c3d.png",
    status: "Visitor",
    dob: "05/30/1957",
  },
  {
    id: "47919",
    lastName: "Neuroth",
    firstName: "Michael Ray",
    phoneCell: "720-649-2779",
    photoUrl: "/clients/image_6a2af3160d530.png",
    status: "Visitor",
    dob: "04/27/1952",
  },
  {
    id: "43155",
    lastName: "Nguyen",
    firstName: "Ba",
    phoneHome: "303-875-4058",
    phoneCell: "720-939-0260",
    photoUrl: "/clients/image_68a5f9082b319.png",
    status: "Approved",
    dob: "10/18/1953",
  },
  {
    id: "48644",
    lastName: "Nguyen",
    firstName: "Binh Thi",
    phoneCell: "720-651-0794",
    status: "Visitor",
    dob: "07/03/1942",
  },
  {
    id: "42755",
    lastName: "Nguyen",
    firstName: "Chau Thi",
    phoneCell: "720-272-6936",
    photoUrl: "/clients/image_689b95b454a7f.png",
    status: "Approved",
    dob: "07/27/1944",
  },
  {
    id: "46302",
    lastName: "Nguyen",
    firstName: "Cuong",
    phoneCell: "720-285-5372",
    photoUrl: "/clients/image_699359599585c.png",
    status: "Approved",
    dob: "01/19/1956",
  },
  {
    id: "38566",
    lastName: "Nguyen",
    firstName: "Duong Thi",
    phoneCell: "720-462-1271",
    photoUrl: "/clients/image_6776da0e5f7a3.png",
    status: "Approved",
    dob: "05/02/1941",
  },
  {
    id: "42506",
    lastName: "Nguyen",
    firstName: "Hoa Van",
    phoneHome: "303-476-3612",
    phoneCell: "720-252-1106",
    photoUrl: "/clients/image_686d48b1b1833.png",
    status: "Approved",
    dob: "05/30/1952",
  },
  {
    id: "38794",
    lastName: "Nguyen",
    firstName: "Hoang Thi",
    phoneCell: "720-231-4397",
    photoUrl: "/clients/image_678fe8198bc83.png",
    status: "Approved",
    dob: "02/03/1957",
  },
  {
    id: "34290",
    lastName: "Nguyen",
    firstName: "Hue",
    phoneCell: "720-352-2062",
    photoUrl: "/clients/image_66c61fffba815.png",
    status: "Approved",
    dob: "02/10/1961",
  },
  {
    id: "34289",
    lastName: "Nguyen",
    firstName: "Hue Thi",
    phoneCell: "720-285-8590",
    photoUrl: "/clients/image_66fc39ea61704.png",
    status: "Approved",
    dob: "01/02/1958",
  },
  {
    id: "47304",
    lastName: "Nguyen",
    firstName: "Lang T",
    phoneCell: "720-419-7066",
    photoUrl: "/clients/image_69ebc038f07c9.png",
    status: "Visitor",
    dob: "06/16/1954",
  },
  {
    id: "47305",
    lastName: "Nguyen",
    firstName: "Loc Thi",
    phoneHome: "720-903-6680",
    phoneCell: "720-903-6680",
    photoUrl: "/clients/image_69ebac1681c96.png",
    status: "Visitor",
    dob: "05/05/1940",
  },
  {
    id: "42489",
    lastName: "Nguyen",
    firstName: "Minh Ngoc",
    phoneCell: "720-236-7332",
    photoUrl: "/clients/image_686c10bb78a85.png",
    status: "Approved",
    dob: "10/28/1952",
  },
  {
    id: "37895",
    lastName: "Nguyen",
    firstName: "Mong Thu Thi",
    phoneCell: "720-207-4394",
    photoUrl: "/clients/image_6722709f7ab34.png",
    status: "Approved",
    dob: "04/17/1949",
  },
  {
    id: "38723",
    lastName: "Nguyen",
    firstName: "Nguyen Thi",
    phoneCell: "720-799-4118",
    photoUrl: "/clients/image_678aacbb3504b.png",
    status: "Approved",
    dob: "06/20/1976",
  },
  {
    id: "37898",
    lastName: "Nguyen",
    firstName: "Nguyet Thi",
    phoneCell: "720-584-3122",
    photoUrl: "/clients/image_670ec22e58abd.png",
    status: "Approved",
    dob: "12/05/1946",
  },
  {
    id: "48642",
    lastName: "Nguyen",
    firstName: "Nhung Dinh",
    phoneCell: "303-798-8771",
    status: "Visitor",
    dob: "06/10/1951",
  },
  {
    id: "42100",
    lastName: "Nguyen",
    firstName: "Niem Thi",
    phoneCell: "720-736-6499",
    photoUrl: "/clients/image_6849dcea024ac.png",
    status: "Approved",
    dob: "08/04/1937",
  },
  {
    id: "42528",
    lastName: "Nguyen",
    firstName: "Nu Thi",
    phoneCell: "303-931-1484",
    photoUrl: "/clients/image_687153e858145.png",
    status: "Approved",
    dob: "10/15/1960",
  },
  {
    id: "44053",
    lastName: "Nguyen",
    firstName: "Phuong Lan",
    phoneHome: "720-492-3599",
    phoneCell: "720-492-3599",
    photoUrl: "/clients/image_68d6cfc70e330.png",
    status: "Approved",
    dob: "09/21/1949",
  },
  {
    id: "38329",
    lastName: "Nguyen",
    firstName: "Phuong Thi",
    phoneCell: "303-332-2104",
    photoUrl: "/clients/image_6758a67311e9f.png",
    status: "Approved",
    dob: "07/16/1949",
  },
  {
    id: "45889",
    lastName: "Nguyen",
    firstName: "Phuong Thi",
    phoneCell: "720-207-4789",
    photoUrl: "/clients/image_6979110ced390.png",
    status: "Visitor",
    dob: "09/27/1949",
  },
  {
    id: "32983",
    lastName: "Nguyen",
    firstName: "Sen",
    phoneCell: "720-212-7688",
    photoUrl: "/clients/image_66289a13a2e20.png",
    status: "Approved",
    dob: "01/16/1950",
  },
  {
    id: "40293",
    lastName: "Nguyen",
    firstName: "Thanh Thi",
    phoneCell: "720-850-7911",
    photoUrl: "/clients/image_67bca859ede20.png",
    status: "Approved",
    dob: "05/18/1955",
  },
  {
    id: "47553",
    lastName: "Nguyen",
    firstName: "Thanh Van",
    phoneCell: "720-656-0113",
    photoUrl: "/clients/image_6a0372497039e.png",
    status: "Visitor",
    dob: "03/25/1967",
  },
  {
    id: "45062",
    lastName: "Nguyen",
    firstName: "Thi Manh",
    phoneHome: "720-655-6035",
    photoUrl: "/clients/image_692601046a320.png",
    status: "Approved",
    dob: "03/12/1945",
  },
  {
    id: "34656",
    lastName: "Nguyen",
    firstName: "Thinh Phuc",
    phoneCell: "720-666-1059",
    photoUrl: "/clients/image_67226a5f76536.png",
    status: "Approved",
    dob: "02/17/1953",
  },
  {
    id: "38031",
    lastName: "Nguyen",
    firstName: "Thu Thuy Thi",
    phoneHome: "720-934-0741",
    phoneCell: "303-856-6453",
    photoUrl: "/clients/image_67211abf6be05.png",
    status: "Approved",
    dob: "09/07/1950",
  },
  {
    id: "44588",
    lastName: "Nguyen",
    firstName: "Thuat",
    phoneHome: "720-341-6587",
    phoneCell: "720-251-9540",
    photoUrl: "/clients/image_6904ff9b1dba9.png",
    status: "Approved",
    dob: "10/15/1949",
  },
  {
    id: "32982",
    lastName: "Nguyen",
    firstName: "Tin",
    phoneHome: "720-212-7688",
    phoneCell: "720-212-7688",
    photoUrl: "/clients/image_662895c36610a.png",
    status: "Approved",
    dob: "01/15/1953",
  },
  {
    id: "33012",
    lastName: "Park",
    firstName: "Chung Hui",
    phoneCell: "347-677-4315",
    photoUrl: "/clients/image_6635440c72e83.png",
    status: "Approved",
    dob: "11/20/1952",
  },
  {
    id: "33685",
    lastName: "Park",
    firstName: "Soon Ok",
    phoneCell: "303-378-7338",
    photoUrl: "/clients/image_6650d32b8aa7d.png",
    status: "Approved",
    dob: "12/05/1947",
  },
  {
    id: "47201",
    lastName: "Parra de Rocha",
    firstName: "Maria",
    phoneCell: "303-434-3320",
    photoUrl: "/clients/image_6a0763ed51f20.png",
    status: "Visitor",
    dob: "05/17/1950",
  },
  {
    id: "47319",
    lastName: "Pham",
    firstName: "Hai Van",
    phoneCell: "408-644-8674",
    photoUrl: "/clients/image_69f10181779dc.png",
    status: "Visitor",
    dob: "01/01/1959",
  },
  {
    id: "38567",
    lastName: "Pham",
    firstName: "Khai Ba",
    phoneHome: "720-850-7911",
    phoneCell: "720-850-7911",
    photoUrl: "/clients/image_6776e1864c04c.png",
    status: "Approved",
    dob: "03/15/1942",
  },
  {
    id: "47400",
    lastName: "Pham",
    firstName: "Lieu Thi Bich",
    status: "Visitor",
    dob: "05/20/1959",
  },
  {
    id: "38587",
    lastName: "Pham",
    firstName: "Phach Quang",
    phoneCell: "720-999-8675",
    photoUrl: "/clients/image_677c3001e8655.png",
    status: "Approved",
    dob: "06/18/1946",
  },
  {
    id: "45888",
    lastName: "Pham",
    firstName: "Thang Van",
    phoneCell: "720-207-4789",
    photoUrl: "/clients/image_699cbb5cc31e1.png",
    status: "Visitor",
    dob: "10/16/1948",
  },
  {
    id: "48288",
    lastName: "Phan",
    firstName: "Lanh Thi",
    phoneCell: "720-919-8072",
    photoUrl: "/clients/image_6a441749ab9fa.png",
    status: "Visitor",
    dob: "07/18/1952",
  },
  {
    id: "38016",
    lastName: "Phan",
    firstName: "Tung Van",
    phoneCell: "720-238-0686",
    photoUrl: "/clients/image_6722804d50625.png",
    status: "Approved",
    dob: "02/15/1939",
  },
  {
    id: "33634",
    lastName: "Phung",
    firstName: "Phuc",
    phoneHome: "303-264-9768",
    phoneCell: "303-264-9768",
    photoUrl: "/clients/image_664e389d750d8.png",
    status: "Approved",
    dob: "03/09/1940",
  },
  {
    id: "47340",
    lastName: "Pitchford",
    firstName: "Carolyn",
    phoneCell: "303-752-3433",
    photoUrl: "/clients/image_69ef95fa13e4d.png",
    status: "Visitor",
    dob: "02/03/1951",
  },
  {
    id: "47751",
    lastName: "Prieto",
    firstName: "Martha Elena",
    phoneCell: "720-327-4506",
    photoUrl: "/clients/image_6a172455246c2.png",
    status: "Visitor",
    dob: "05/12/1952",
  },
  {
    id: "45470",
    lastName: "Ramos",
    firstName: "Felix Armando",
    phoneCell: "720-415-9482",
    photoUrl: "/clients/image_695811df8982e.png",
    status: "Approved",
    dob: "06/09/1937",
  },
  {
    id: "47770",
    lastName: "Romero",
    firstName: "Isabel Salome",
    phoneCell: "303-513-6941",
    photoUrl: "/clients/image_6a18901f44c45.png",
    status: "Visitor",
    dob: "05/30/1947",
  },
  {
    id: "46136",
    lastName: "Sample",
    firstName: "Training",
    phoneCell: "555-415-5874",
    status: "Visitor",
    dob: "11/27/1934",
  },
  {
    id: "47039",
    lastName: "Sanchez",
    firstName: "Maxine L",
    phoneCell: "303-964-8603",
    photoUrl: "/clients/image_6a0765aa9a2ba.png",
    status: "Visitor",
    dob: "04/21/1947",
  },
  {
    id: "47673",
    lastName: "Say",
    firstName: "Chanthy",
    phoneCell: "720-280-8174",
    status: "Visitor",
    dob: "02/12/1960",
  },
  {
    id: "33013",
    lastName: "Scott",
    firstName: "Yong Sun",
    phoneCell: "303-859-1335",
    photoUrl: "/clients/image_662bdd62e92f9.png",
    status: "Approved",
    dob: "05/05/1950",
  },
  {
    id: "47555",
    lastName: "Smith Williams",
    firstName: "Barbara",
    phoneCell: "720-629-5163",
    photoUrl: "/clients/image_6a03726f7f7c3.png",
    status: "Visitor",
    dob: "07/13/1947",
  },
  {
    id: "33929",
    lastName: "Song",
    firstName: "Jae Ock",
    phoneCell: "720-877-1523",
    photoUrl: "/clients/image_667bbe1c8ec6c.png",
    status: "Approved",
    dob: "05/19/1948",
  },
  {
    id: "43034",
    lastName: "To",
    firstName: "Nguyet Anh",
    phoneCell: "313-240-1218",
    photoUrl: "/clients/image_68d19522ea27a.png",
    status: "Approved",
    dob: "12/31/1945",
  },
  {
    id: "47749",
    lastName: "Torres Magana",
    firstName: "Maria Luisa",
    phoneCell: "720-269-9352",
    photoUrl: "/clients/image_6a1718d2688df.png",
    status: "Visitor",
    dob: "11/08/1942",
  },
  {
    id: "43446",
    lastName: "Tran",
    firstName: "Duyen Thi",
    phoneHome: "720-238-0691",
    phoneCell: "720-238-0691",
    photoUrl: "/clients/image_68c04dfdbfa09.png",
    status: "Approved",
    dob: "01/05/1952",
  },
  {
    id: "47664",
    lastName: "Tran",
    firstName: "Nhuy Ngoc",
    phoneCell: "720-217-7175",
    photoUrl: "/clients/image_6a0e1730082ee.png",
    status: "Visitor",
    dob: "07/14/1948",
  },
  {
    id: "40317",
    lastName: "Tran",
    firstName: "Tan",
    phoneCell: "720-292-4111",
    photoUrl: "/clients/image_67b7774280b9d.png",
    status: "Approved",
    dob: "10/17/1959",
  },
  {
    id: "34118",
    lastName: "Tran",
    firstName: "Thuong",
    phoneCell: "720-492-0397",
    photoUrl: "/clients/image_669fd8b3683c3.png",
    status: "Approved",
    dob: "01/01/1954",
  },
  {
    id: "46831",
    lastName: "Tran",
    firstName: "Thuong T",
    status: "Approved",
    dob: "07/05/1935",
  },
  {
    id: "33228",
    lastName: "Tran",
    firstName: "Tri",
    phoneCell: "303-755-1118",
    photoUrl: "/clients/image_663e5105c0ea8.png",
    status: "Approved",
    dob: "11/16/1961",
  },
  {
    id: "38180",
    lastName: "Tschoe",
    firstName: "Yang Hee",
    phoneCell: "303-669-0314",
    photoUrl: "/clients/image_68f2839d8f640.png",
    status: "Approved",
    dob: "10/29/1950",
  },
  {
    id: "46416",
    lastName: "Tu",
    firstName: "Hien",
    phoneCell: "720-999-2828",
    photoUrl: "/clients/image_699e169b5c76c.png",
    status: "Approved",
    dob: "01/25/1954",
  },
  {
    id: "33641",
    lastName: "Uong",
    firstName: "Kien Ngoc",
    phoneCell: "720-392-3095",
    photoUrl: "/clients/image_668d5e621311c.png",
    status: "Visitor",
    dob: "09/06/1948",
  },
  {
    id: "38588",
    lastName: "Vo",
    firstName: "Gai Thi",
    phoneCell: "720-499-7410",
    photoUrl: "/clients/image_6a2c2e18a1704.png",
    status: "Visitor",
    dob: "03/19/1947",
  },
  {
    id: "33636",
    lastName: "Vo",
    firstName: "Nam",
    phoneCell: "720-935-6875",
    photoUrl: "/clients/image_664e391dd59e1.png",
    status: "Approved",
    dob: "01/01/1945",
  },
  {
    id: "32966",
    lastName: "Vong",
    firstName: "Bao",
    phoneHome: "303-257-2198",
    phoneCell: "720-253-9156",
    photoUrl: "/clients/image_67588b5899920.png",
    status: "Approved",
    dob: "10/01/1947",
  },
  {
    id: "47693",
    lastName: "Vovan",
    firstName: "Pauline Tran",
    status: "Visitor",
    dob: "01/12/1969",
  },
  {
    id: "31840",
    lastName: "Vu",
    firstName: "Tommy",
    phoneHome: "303-999-8891",
    photoUrl: "/clients/image_673e4602d6bb9.png",
    status: "Approved",
    dob: "05/11/1945",
  },
  {
    id: "42998",
    lastName: "Vuong",
    firstName: "Xuan Le",
    phoneCell: "720-544-1210",
    photoUrl: "/clients/image_689a4700cfe24.png",
    status: "Approved",
    dob: "06/26/1967",
  },
  {
    id: "47424",
    lastName: "Webb",
    firstName: "Joann",
    phoneCell: "870-729-4759",
    photoUrl: "/clients/image_69f4c687aeb38.png",
    status: "Approved",
    dob: "07/12/1970",
  },
  {
    id: "48337",
    lastName: "Webster",
    firstName: "Kim Young",
    phoneCell: "720-234-2127",
    status: "Visitor",
    dob: "11/28/1962",
  },
  {
    id: "31842",
    lastName: "Wen",
    firstName: "Yahao",
    phoneHome: "303-931-5332",
    phoneCell: "720-641-2986",
    photoUrl: "/clients/image_667b082311a57.png",
    status: "Approved",
    dob: "01/01/1948",
  },
  {
    id: "46225",
    lastName: "Williams",
    firstName: "Brenda",
    phoneHome: "983-219-5161",
    photoUrl: "/clients/image_69f102f1f335e.png",
    status: "Approved",
    dob: "02/18/1954",
  },
  {
    id: "33927",
    lastName: "XIANG",
    firstName: "MEI SAN",
    phoneCell: "720-252-1141",
    photoUrl: "/clients/image_66884c3cb513d.png",
    status: "Approved",
    dob: "07/16/1947",
  },
  {
    id: "37851",
    lastName: "Xu",
    firstName: "Jiao Tu",
    phoneCell: "720-503-5327",
    photoUrl: "/clients/image_6705763bbaae2.png",
    status: "Approved",
    dob: "04/04/1949",
  },
  {
    id: "33928",
    lastName: "YU",
    firstName: "JUNG KEUM",
    phoneHome: "720-939-5360",
    phoneCell: "720-827-1189",
    photoUrl: "/clients/image_667bbc3919053.png",
    status: "Approved",
    dob: "12/30/1948",
  },
]

export function getClientById(id: string): ClientProfile | undefined {
  return MOCK_CLIENTS.find((c) => c.id === id)
}

export function displayName(client: Pick<ClientProfile, 'firstName' | 'lastName'>): string {
  return `${client.lastName}, ${client.firstName}`
}

export function statusCounts() {
  const all = MOCK_CLIENTS.length
  const approved = MOCK_CLIENTS.filter((c) => c.status === 'Approved').length
  const visitors = MOCK_CLIENTS.filter((c) => c.status === 'Visitor').length
  const discharged = MOCK_CLIENTS.filter((c) => c.status === 'Discharged').length
  const hold = MOCK_CLIENTS.filter((c) => c.status === 'Hold').length
  const potential = MOCK_CLIENTS.filter((c) => c.status === 'Potential').length
  return { all, approved, visitors, discharged, hold, potential }
}
